import { render } from "./orders-subpage.vue?vue&type=template&id=318016f4"
import script from "./orders-subpage.vue?vue&type=script&lang=js"
export * from "./orders-subpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__